import { Icon } from '@iconify/react';
import Link from 'next/link';

export default function ListLinks({ items }) {
  return (
    <div className="flex flex-col divide-y border-neutral-100">
      {items.map(({ url, textStart, textMiddle, textEnd }, i) => (
        <Link key={i} href={url}>
          <a className="flex items-center gap-4 py-8 px-4 transition hover:bg-neutral-100 focus:bg-neutral-200 lg:gap-8">
            <div className="flex flex-1 flex-col gap-2 lg:flex-row lg:gap-4">
              {textStart && <h3 className="flex-1 text-xl leading-tight">{textStart}</h3>}
              <div className="flex max-w-xs items-center gap-4 lg:gap-8">
                {textMiddle && <span className="font-light text-neutral-600">{textMiddle}</span>}
                {textEnd && <span className="font-light text-neutral-600">{textEnd}</span>}
              </div>
            </div>
            <Icon className="text-neutral-500" height="24" icon="fluent:chevron-right-24-filled" />
          </a>
        </Link>
      ))}
    </div>
  );
}
